// extracted by mini-css-extract-plugin
module.exports = {"component":"PartnerLogo_component__3f3UG","mobile":"PartnerLogo_mobile__2dzcl","mindsetLogo":"PartnerLogo_mindsetLogo__2C7f4","image":"PartnerLogo_image__1pH17"};